import { render, staticRenderFns } from "./send-box.vue?vue&type=template&id=53809b22&"
import script from "./send-box.vue?vue&type=script&lang=js&"
export * from "./send-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports